import { ActivityEntityName } from '@jms/model';
import { clientPaths } from '@jms/tenant/module.jms.authorisation';
import { Command } from '@workbuddy/ui/model';
import { clientCsvDownloadCommands } from '../../shared/client.csv.download';

export function clientUpcomingWorkCsvCommands(): Command[] {

  return clientCsvDownloadCommands({ entity: ActivityEntityName.UpcomingWork, path: clientPaths.Services, commandId: 'services.download-csv', title: 'Services' });
}
